<script lang="ts">
  import { getContext } from 'svelte';
  import Share from '../assets/icons/Share.svelte';
  import type { PlayerStateContext } from '../types/player-state';
  import type { FocusItem, FocusLayer } from '../focus-manager/focus-types';
  import IconButton from './IconButton.svelte';

  export let focusLayer: FocusLayer;
  export let focusName: FocusItem;

  const { linkToShare } = getContext<PlayerStateContext>('playerState');

  const feedbackTimeInMs = 3000;
  const clipboardSupported = 'clipboard' in navigator && typeof navigator.clipboard.writeText === 'function';
  $: shareButtonAvailable = clipboardSupported && $linkToShare;

  let feedbackText: string | undefined;
  let timeoutId: ReturnType<typeof setTimeout>;

  const copyToClipboard = async () => {
    if (!$linkToShare) {
      return;
    }

    clearTimeout(timeoutId);

    try {
      await navigator.clipboard.writeText($linkToShare);
      feedbackText = 'Link wurde kopiert';
    } catch {
      feedbackText = 'Link konnte nicht kopiert werden';
    }

    timeoutId = setTimeout(() => {
      feedbackText = undefined;
    }, feedbackTimeInMs);
  };
</script>

{#if shareButtonAvailable}
  <div class="share-button-container">
    {#if feedbackText}
      <div class="feedback" role="status" aria-label="Link teilen">
        {feedbackText}
      </div>
    {/if}
    <IconButton on:click={copyToClipboard} title="Link in die Zwischenablage legen" {focusLayer} {focusName}>
      <Share aria-hidden={true} />
    </IconButton>
  </div>
{/if}

<style module>
  .share-button-container {
    position: relative;
  }

  .feedback {
    color: #ffffff; /* Fallback for older browsers */
    color: var(--tooltip-color);
    background: #000000; /* fallback for old browsers */
    background: var(--tooltip-background);
    white-space: nowrap;
    padding: 12px;
    position: absolute;
    bottom: 100%;
    margin-bottom: 2px;
    right: 0;
  }
</style>
